import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a61bbe6c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a61bbe6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61bbe6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a61bbe6c')) {
      api.createRecord('a61bbe6c', component.options)
    } else {
      api.reload('a61bbe6c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a61bbe6c&scoped=true&", function () {
      api.rerender('a61bbe6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/modules/product-name-rule/index.vue"
export default component.exports